import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { useLocation } from 'react-router-dom';
import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount";
import { RingLoader } from 'react-spinners';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, TableFooter } from "@mui/material";
import { FormaDateBalanceSheet } from "../../../Common/FormatFunctions/FormatDate"
import PdfPreview from '../../../Common/PDFPreview';

const apikey = process.env.REACT_APP_API;

const AwakRegister = () => {
  const location = useLocation();
  const Company_Name = sessionStorage.getItem('Company_Name')
  const Company_GSTNO = sessionStorage.getItem('Company_GSTNO')
  const searchParams = new URLSearchParams(location.search);
  // const fromDate = searchParams.get('fromDate');
  // const toDate = searchParams.get('toDate');
  const company_Code = searchParams.get('Company_Code');
  const Year_Code = searchParams.get('Year_Code');
  // const Ac_code = searchParams.get('Ac_code');
  const [pdfPreview, setPdfPreview] = useState(null);

  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [grandTotals, setGrandTotals] = useState({
    TotalTaxable_Amt: 0,
    CGSTAmt: 0,
    SGSTAmt: 0,
    IGSTAmt: 0,
    BillamountAmt: 0,
    Awak_Qty: 0
  });

  const API_URL = `${apikey}/PartyStockBookreport`;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear());
    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    const fetchReportData = async () => {
      setLoading(true);
      setError('');
      try {
        const response = await axios.get(API_URL, {
          params: {
            // from_date: fromDate,
            // to_date: toDate,
            Company_Code: company_Code,
            Year_Code: Year_Code,
            // Ac_code: Ac_code
          },
        });
        setReportData(response.data);
      } catch (error) {
        console.error('Error fetching report:', error);
        setError('Error fetching report');
      } finally {
        setLoading(false);
      }
    };

    fetchReportData();
  }, [API_URL]);

  useEffect(() => {
    if (reportData.length > 0) {
      const totals = reportData.reduce(
        (acc, item) => {
          acc.Awak_Qty += Number(item.Awak_Qty) || 0;
          return acc;
        },
        { TotalTaxable_Amt: 0, CGSTAmt: 0, SGSTAmt: 0, IGSTAmt: 0, BillamountAmt: 0, Awak_Qty: 0 }
      );

      setGrandTotals(totals);
    }
  }, [reportData]);

  const handleExportToExcel = () => {
    const wb = XLSX.utils.book_new();
    const headers = [
      "Awak No", "Date", "Farmer Code", "Farmer Name", "Item Name", "Godown Name", "Line Name", "Quantity", "Despatched", "Balance", "Auction Mark",
    ];

    const formattedData = reportData.map(item => ({
      "Awak No": item.Doc_No,
      "Date": item.Doc_Date,
      "Farmer Code": item.Ac_code,
      "Farmer Name": item.FarmerName,
      "Item Name": item.System_Name_E,
      "Godown Name": item.GodownName,
      "Line Name": item.LineName,
      "Quantity": Number(item.Awak_Qty) || 0,
      "Despatched": item.despatched,
      "Balance": Number(item.balance) || 0,
      "Auction Mark": item.AuctionMark || "",
      // "SGST Amt": Number(item.SGSTAmount) || 0,
      // "IGST Amt": Number(item.IGSTAmount) || 0,
      // "Bill Amount": Number(item.Bill_Amount) || 0
    }));
    const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });
    const wsCols = [
      { wch: 12, alignment: { horizontal: "left" } },    // Awak No
      { wch: 15, alignment: { horizontal: "center" } },  // Date
      { wch: 12, alignment: { horizontal: "center" } },  // Farmer Code
      { wch: 25, alignment: { horizontal: "right" } },    // Farmer Name
      { wch: 25, alignment: { horizontal: "left" } },    // Item Name
      { wch: 25, alignment: { horizontal: "left" } },    // Godown Name
      { wch: 25, alignment: { horizontal: "left" } },    // Line Name
      { wch: 12, alignment: { horizontal: "right" } },   // Quantity
      { wch: 12, alignment: { horizontal: "right" } },   // Despatched
      { wch: 12, alignment: { horizontal: "right" } },   // Balance
      { wch: 15, alignment: { horizontal: "left" } },    // Auction Mark
    ];


    ws["!cols"] = wsCols;
    XLSX.utils.book_append_sheet(wb, ws, 'PartyStock');
    XLSX.writeFile(wb, 'PartyStock.xlsx');
  };

  const handlePrint = () => {
    const companyName = Company_Name;
    // const fromDateParam = searchParams.get('fromDate');
    // const toDateParam = searchParams.get('toDate');

    const doc = generatePDFDocument(companyName,);
    const pdfUrl = URL.createObjectURL(doc);
    const printWindow = window.open(pdfUrl);
    printWindow.onload = function () {
      setTimeout(() => {
        printWindow.print();
      }, 500);
    };
  };

  const generatePDFDocument = (companyName,) => {
    const doc = new jsPDF();

    // Add header information
    doc.setFontSize(12);
    doc.setFont(undefined, 'bold');
    doc.text(companyName, doc.internal.pageSize.width / 2, 15, { align: 'center' });

    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');
    doc.text(`GSTN : ${Company_GSTNO}`, doc.internal.pageSize.width / 2, 23, { align: 'center' });

    doc.setFontSize(12);
    doc.setFont(undefined, 'bold');
    doc.text("Party Stock", doc.internal.pageSize.width / 2, 32, { align: 'center' });

    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');
    // doc.text(`${FormaDateBalanceSheet(fromDate)} to ${FormaDateBalanceSheet(toDate)}`, doc.internal.pageSize.width / 2, 40, { align: 'center' });

    const startY = 45;

    // Prepare table data
    const tableData = [
      [
        "Awak No", "Date", "Farmer Code", "Farmer Name", "Item Name", "Godown Name", "Line Name", "Quantity", "Despatched", "Balance", "Auction Mark",
      ],
      ...reportData.map(item => [
        item.Doc_No,
        item.Doc_Date,
        item.Ac_code,
        item.FarmerName,
        item.System_Name_E,
        item.GodownName,
        item.LineName,
        formatReadableAmount(item.Awak_Qty),
        formatReadableAmount(item.despatched),
        formatReadableAmount(item.balance),
        item.AuctionMark,
        // formatReadableAmount(item.SGSTAmount),
        // formatReadableAmount(item.IGSTAmount),
        // formatReadableAmount(item.Bill_Amount),
      ]),
      [
        '', '', '', '','','', 'Total',
        formatReadableAmount(grandTotals.Awak_Qty),
        '',
        // formatReadableAmount(grandTotals.TotalTaxable_Amt),
        // formatReadableAmount(grandTotals.CGSTAmt),
        // formatReadableAmount(grandTotals.SGSTAmt),
        // formatReadableAmount(grandTotals.IGSTAmt),
        // formatReadableAmount(grandTotals.BillamountAmt)
      ]
    ];

    // Add table to PDF
    doc.autoTable({
      head: [tableData[0]],
      body: tableData.slice(1, -1),
      foot: [tableData[tableData.length - 1]],
      startY: startY,
      styles: {
        fontSize: 6,
        cellPadding: { top: 0.5, bottom: 0.5, left: 1, right: 1 },
        halign: 'center',
      },
      headStyles: {
        fillColor: [255, 0, 0],
        textColor: [255, 255, 255],
        fontStyle: 'bold',
      },
      footStyles: {
        fillColor: [255, 255, 0],
        textColor: [0, 0, 0],
        fontStyle: 'bold',
      },
      columnStyles: {
        0: {cellWidth: 12, halign: 'left' },    // Awak No
        1: { halign: 'center' },  // Date
        2: {cellWidth: 15, halign: 'center' },  // Farmer Code
        3: { halign: 'left' },    // Farmer Name
        4: {cellWidth: 15, halign: 'center' },    // Item Name
        5: { cellWidth: 20,halign: 'center' },    // Godown Name
        6: { cellWidth: 14,halign: 'center' },    // Line Name
        7: { halign: 'center' },   // Quantity
        8: { halign: 'center' },   // Despatched
        9: { cellWidth: 12,halign: 'center' },   // Balance
        10: { cellWidth: 20,halign: 'center' },  // Auction Mark
      },
      margin: { top: startY },
    });

    const pdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);
    setPdfPreview(pdfUrl);
    return pdfBlob;
  };
  // Group data by Ac_Code
  const groupByAcCode = (data) => {
    const grouped = {};
    data.forEach(item => {
      const acKey = item.Ac_code;
      if (!grouped[acKey]) {
        grouped[acKey] = {
          // farmerName: item.FarmerACName,
          awakNo: item.Doc_No,
          items: [],
          totalQty: 0
        };
      }
      grouped[acKey].items.push(item);
      grouped[acKey].totalQty += Number(item.Awak_Qty) || 0;
    });
    return grouped;
  };

  const groupedByAc = groupByAcCode(reportData);



  const groupReportData = (data) => {
    const groupedData = {};
    data.forEach((item) => {
      const key = `${item.Id}`;
      if (!groupedData[key]) {
        groupedData[key] = {
          items: [],
          totalQty: 0,
        };
      }
      groupedData[key].items.push(item);
      // groupedData[key].totalQty += parseFloat(item.Bill_Amount) || 0;
    });
    return groupedData;
  };

  const groupedReportData = groupReportData(reportData);

  return (
    <div style={{ marginTop: "10px" }}>
      <Typography variant="h6" style={{ textAlign: 'center', fontSize: "24px", fontWeight: "bold" }}>{Company_Name}</Typography>
      <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px", textDecoration: 'underline', fontWeight: "550" }}>GSTN : {Company_GSTNO}</Typography>
      <Typography variant="h6" style={{ textAlign: 'center', fontSize: "20px", fontWeight: "bold" }}>Party Stock</Typography>
      {/* <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px" }}>{fromDate ? FormaDateBalanceSheet(fromDate) : ""} to {toDate ? FormaDateBalanceSheet(toDate) : ""}</Typography> */}

      <div className="mb-3 row align-items-center">
        <div className="col-auto">
          <button className="btn btn-secondary me-2" onClick={handlePrint}>
            Print
          </button>
          <button className="btn btn-success" onClick={handleExportToExcel}>
            Export to Excel
          </button>
          <button className="btn btn-secondary me-2" onClick={() => generatePDFDocument(Company_Name,)}>
            Preview PDF
          </button>
          {pdfPreview && (
            <PdfPreview
              pdfData={pdfPreview}
              apiData={reportData[0]}
              label={"SaleRegister"}
            />
          )}
        </div>
      </div>

      <div style={{
        maxHeight: 'calc(100vh - 200px)',
        overflow: 'auto',
        position: 'relative',
        border: '1px solid #e0e0e0',
        marginBottom: '60px'
      }} id="reportTable">
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead sx={{
            position: 'sticky',
            top: 0,
            zIndex: 1,
            backgroundColor: 'white'
          }}>
            <TableRow>
              <TableCell style={{ textAlign: "left", fontWeight: "bold", backgroundColor: 'white' }}>Awak No</TableCell>
              <TableCell style={{ textAlign: "center", fontWeight: "bold", backgroundColor: 'white' }}>Date</TableCell>
              <TableCell style={{ textAlign: "center", fontWeight: "bold", backgroundColor: 'white' }}>Farmer Code</TableCell>
              <TableCell style={{ textAlign: "left", fontWeight: "bold", backgroundColor: 'white' }}>Farmer Name</TableCell>
              <TableCell style={{ textAlign: "center", fontWeight: "bold", backgroundColor: 'white' }}>Customer Code</TableCell>
              <TableCell style={{ textAlign: "left", fontWeight: "bold", backgroundColor: 'white' }}>Customer Name</TableCell>
              <TableCell style={{ textAlign: "left", fontWeight: "bold", backgroundColor: 'white' }}>Item Name</TableCell>
              <TableCell style={{ textAlign: "left", fontWeight: "bold", backgroundColor: 'white' }}>Godown Name</TableCell>
              <TableCell style={{ textAlign: "left", fontWeight: "bold", backgroundColor: 'white' }}>Line Name</TableCell>
              <TableCell style={{ textAlign: "right", fontWeight: "bold", backgroundColor: 'white' }}>Quantity</TableCell>
              <TableCell style={{ textAlign: "right", fontWeight: "bold", backgroundColor: 'white' }}>Despatched</TableCell>
              <TableCell style={{ textAlign: "right", fontWeight: "bold", backgroundColor: 'white' }}>Balance</TableCell>
              <TableCell style={{ textAlign: "right", fontWeight: "bold", backgroundColor: 'white' }}>Auction Mark</TableCell>
              {/* <TableCell style={{ textAlign: "right", fontWeight: "bold", backgroundColor: 'white' }}>IGST Amount</TableCell>
              <TableCell style={{ textAlign: "right", fontWeight: "bold", backgroundColor: 'white' }}>Bill Amount</TableCell> */}
            </TableRow>
          </TableHead>

          {/* <TableBody>
            {Object.entries(groupedReportData).map(([key, { items, totalQty }]) => {
              return (
                <React.Fragment key={key}>
                  {items.map((item, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        cursor: "pointer",
                        "&:hover": {
                          backgroundColor: "#fdfd96",
                        },
                      }}
                    >
                      <TableCell style={{ textAlign: "left" }}>{item.Doc_No}</TableCell>
                      <TableCell style={{ textAlign: "center" }}>{formatDate(item.Doc_Date)}</TableCell>
                      <TableCell style={{ textAlign: "left" }}>{item.FarmerACName}</TableCell>
                      <TableCell style={{ textAlign: "left" }}>{item.DetailItemName}</TableCell>
                      <TableCell style={{ textAlign: "right" }}>
                        {formatReadableAmount(item.Awak_Qty)}
                      </TableCell> */}
          {/* <TableCell style={{ textAlign: "right" }}>{item.gstrate}</TableCell>
                      <TableCell style={{ textAlign: "right" }}>
                        {formatReadableAmount(item.TaxableAmount)}
                      </TableCell>
                      <TableCell style={{ textAlign: "right" }}>
                        {formatReadableAmount(item.CGSTAmount)}
                      </TableCell>
                      <TableCell style={{ textAlign: "right" }}>
                        {formatReadableAmount(item.SGSTAmount)}
                      </TableCell>
                      <TableCell style={{ textAlign: "right" }}>
                        {formatReadableAmount(item.IGSTAmount)}
                      </TableCell>
                      <TableCell style={{ textAlign: "right" }}>
                        {formatReadableAmount(item.Bill_Amount)}
                      </TableCell> */}
          {/* </TableRow>
                  ))}
                </React.Fragment>
              );
            })}
          </TableBody> */}

          <TableBody>
            {/* {Object.entries(groupedByAc).map(([acCode, group]) => (
              <React.Fragment key={acCode}> */}
            {/* First row with Awak No and Farmer Name */}
            {/* <TableRow sx={{ backgroundColor: '#f0f0f0', fontWeight: 'bold' }}>
                  <TableCell ></TableCell>
                  <TableCell></TableCell>
                  <TableCell style={{ textAlign: "center", fontWeight: "bold", fontSize: "16px" }}>{group.Doc_No}</TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow> */}

            {/* List all items for this Ac_Code */}
            {Array.isArray(reportData) && reportData.map((item, idx) => (
              <TableRow
                key={idx}
                sx={{
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "#fdfd96" },
                }}
              >

                <TableCell>{item.Doc_No}</TableCell>
                <TableCell style={{ textAlign: "center" }}>{item.Doc_Date}</TableCell>
                <TableCell style={{ textAlign: "center" }}>{item.Ac_code}</TableCell>
                <TableCell style={{ textAlign: "left" }}>{item.FarmerName}</TableCell>
                <TableCell style={{ textAlign: "center" }}>{item.Customer_Code}</TableCell>
                <TableCell style={{ textAlign: "left" }}>{item.CustomerName}</TableCell>
                <TableCell>{item.System_Name_E}</TableCell>
                <TableCell>{item.GodownName}</TableCell>
                <TableCell>{item.LineName}</TableCell>
                <TableCell style={{ textAlign: "right" }}>{formatReadableAmount(item.Awak_Qty)}</TableCell>
                <TableCell style={{ textAlign: "right" }}>{formatReadableAmount(item.despatched)}</TableCell>
                <TableCell style={{ textAlign: "right" }}>{formatReadableAmount(item.balance)}</TableCell>
                <TableCell style={{ textAlign: "right" }}>{item.AuctionMark}</TableCell>
              </TableRow>
            ))}

            {/* Subtotal row for this Ac_Code */}
            <TableRow sx={{ backgroundColor: '#ffff99', fontWeight: 'bold' }}>
              <TableCell colSpan={9} style={{ textAlign: 'right' }}>Total: </TableCell>
              <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(grandTotals.Awak_Qty)}</TableCell>
              <TableCell colSpan={6}></TableCell>

            </TableRow>
            {/* </React.Fragment> */}
            {/* ))} */}
          </TableBody>


          {/* <TableFooter style={{ position: 'sticky', bottom: 0, backgroundColor: 'white', zIndex: 1 }}>
            <TableRow style={{ backgroundColor: "yellow" }}>
              <TableCell colSpan={4} className="fw-bold" style={{ fontWeight: "bold", fontSize: "14px" }}>Total</TableCell>
              <TableCell className="fw-bold text-end" style={{ fontWeight: "bold", fontSize: "14px" }}>{formatReadableAmount(grandTotals.Awak_Qty)}</TableCell>
              <TableCell className="fw-bold"></TableCell> */}
          {/* <TableCell className="fw-bold text-end" style={{ fontWeight: "bold", fontSize: "14px" }}>
                {formatReadableAmount(grandTotals.TotalTaxable_Amt)}
              </TableCell>
              <TableCell className="fw-bold text-end" style={{ fontWeight: "bold", fontSize: "14px" }}>{formatReadableAmount(grandTotals.CGSTAmt)}</TableCell>
              <TableCell className="fw-bold text-end" style={{ fontWeight: "bold", fontSize: "14px" }}>{formatReadableAmount(grandTotals.SGSTAmt)}</TableCell>
              <TableCell className="fw-bold text-end" style={{ fontWeight: "bold", fontSize: "14px" }}>{formatReadableAmount(grandTotals.IGSTAmt)}</TableCell>
              <TableCell className="fw-bold text-end" style={{ fontWeight: "bold", fontSize: "14px" }}>{formatReadableAmount(grandTotals.BillamountAmt)}</TableCell> */}
          {/* </TableRow>
          </TableFooter> */}
        </Table>
      </div>

      {loading && (
        <div style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 9999
        }}>
          <RingLoader size={80} />
        </div>
      )}
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

export default AwakRegister;
